import type { Capability } from '@taler/api-client'

/** The one place this feature's view gate is written; the page and the nav both call it. */
export function canCreateEntries(can: (capability: Capability) => boolean): boolean {
  return can('ENTRY_CREATE')
}
